module.exports = __webpack_public_path__ + "img/bus-splash.b2b85bad.png";